import { IconButton } from "@chakra-ui/react";
import { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";

import { openAddLiveVideoModel } from "../../../modules/admin-modules/models/Actions";
import { deleteLiveVideoRequest } from "../../../modules/superadmin-modules/live-videos/Actions";

const SuperadminLiveVideosTable = ({ setAdd, setSelectedData }) => {
  const { liveVideos, isLoading } = useSelector(
    (state) => state.superadminLiveVideos
  );
  const dispatch = useDispatch();
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = liveVideos?.items?.map((data) => {
    return {
      ...data,
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openAddLiveVideoModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deleteLiveVideoRequest(data?.id, () => {
            // Refresh the list after deletion
            window.location.reload();
          }))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: "العنوان",
      accessor: "title",
    },
    {
      Header: "الرابط",
      accessor: "zoom_link",
    },
    {
      Header: "الدورة",
      accessor: "course.name",
    },
    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(liveVideos?.items?.length / 10)}
    />
  );
};

export default SuperadminLiveVideosTable; 